import React from 'react';
import { useStyles } from './ProgressBadge.style';

interface ProgressProps {
  progress: number;
}

export const ProgressBadge: React.FC<ProgressProps> = (props) => {
  const classes = useStyles();

  return props.progress === 100 ? (
    <div
      className={classes.buttonOutline}
      style={{
        background: '#3560FF',
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: 500,
      }}
    >
      {props.progress}%
    </div>
  ) : (
    <div
      className={classes.buttonOutline}
      style={{
        background: `linear-gradient(90deg, rgba(53, 96, 255, 0.25) ${props.progress}% , #FFFFFF ${
          props.progress - 50
        }%`,
      }}
    >
      {props.progress}%
    </div>
  );
};
